<section class="print-receipt" *ngFor="let page of pages">
    <div class="logo-img" *ngIf="!kitchen_content">
        <cl-image *ngIf="orgType?.image" [public-id]="orgType?.ImageUrl" width="150"></cl-image>
    </div>
    <div class="text-center">
        <h3>{{ orgType?.OrgName }}</h3>
        <h4 *ngIf="kitchen_content">*** {{ page?.kitchenName }} ***</h4>
        <div *ngIf="!kitchen_content">
            <p>{{ orgType?.OrgAddress }}</p>
            <p hidden>Email: {{ orgType?.UserEmail || 'N/A' }}</p>
            <p class="flex-box">
                <span>Ph# {{ orgType?.OrgContactNumber || 'N/A' }}</span>
                <ng-container *ngIf="taxNtnCheck(invoiceData?.tax)">
                    <span>KNTN# {{ orgType?.OrgKNTN || 'N/A' }}</span>
                    <span>STRN# {{ orgType?.OrgSTRN || 'N/A' }}</span>
                    <span>NTN# {{ orgType?.OrgNTN || 'N/A' }}</span>
                </ng-container>
            </p>
        </div>
    </div>
    <table class="comments margin-top-10">
        <tr>
            <th colspan="2"></th>
        </tr>
        <tr>
            <th *ngIf="invoiceData?.OrderTypeId === orderType?.dine_inn?.id">
                <strong>Table #: {{ invoiceData?.table_number || 'N/A' }}</strong>
            </th>
            <th *ngIf="invoiceData?.OrderTypeId !== orderType?.dine_inn?.id">
                <strong>Tracking #: {{ invoiceData?.tracking_id || 'N/A' }}</strong>
            </th>

            <td>
                <strong>Receipt #: {{ invoiceData?.invoice_number }}</strong>
            </td>
        </tr>
        <tr>
            <th>{{ 'webapp.general.date_amp_time' | transloco }}</th>
            <td>{{ printDate }}</td>
        </tr>
        <tr
            *ngIf="
                (orgType?.IsDineInOrderTypeSettingBase ||
                    orgType?.IsDeliveryOrderTypeSettingBase ||
                    orgType?.IsTakeAwayOrderTypeSettingBase) &&
                orgType?.OrderTypeShowInReceipt
            "
            [hidden]="!orgType?.IsRestaurant"
        >
            <th>{{ 'common.labels.type' | transloco }}</th>
            <td>{{ invoiceData?.OrderTypeName || 'N/A' }}</td>
        </tr>
        <tr *ngIf="invoiceData?.waiter?.id && kitchen_content">
            <th>{{ 'webapp.general.userRoles.waiter' | transloco }}</th>
            <td>{{ invoiceData?.WaiterName }}</td>
        </tr>
        <tr *ngIf="invoiceData?.staff?.id && !kitchen_content">
            <th>{{ 'webapp.general.userRoles.cashier' | transloco }}</th>
            <td>
                {{ invoiceData?.staff?.MemberDisplay || invoiceData?.WaiterName }}
            </td>
        </tr>
        <tr
            *ngIf="
                invoiceData?.OrderTypeId === orderType?.delivery?.id &&
                !kitchen_content &&
                invoiceData?.deliverer?.given_name
            "
        >
            <th>{{ 'common.labels.deliverer' | transloco }}</th>
            <td>
                {{ invoiceData?.DelivererName || 'N/A' }}
                <strong>({{ invoiceData?.DelivererContactNumber || 'N/A' }})</strong>
            </td>
        </tr>
        <tr *ngIf="!kitchen_content">
            <th>{{ 'common.labels.customer' | transloco }}</th>
            <td>
                {{ invoiceData?.CustomerName || 'Walk-in' }}
                <strong>({{ invoiceData?.CustomerContactNumber || 'N/A' }})</strong>
            </td>
        </tr>
        <tr *ngIf="invoiceData?.OrderTypeId === orderType?.delivery?.id && !kitchen_content">
            <th>{{ 'webapp.general.delivery_address' | transloco }}</th>
            <td>{{ invoiceData?.CustomerAddress || 'N/A' }}.</td>
        </tr>
    </table>
    <table>
        <tr>
            <th colspan="3"></th>
        </tr>
        <tr>
            <th>
                <strong>{{ 'common.fields.description' | transloco }}</strong>
            </th>
            <th *ngIf="!kitchen_content">
                <strong>{{ 'common.fields.price' | transloco }}</strong>
            </th>
            <th *ngIf="!kitchen_content">
                <strong>{{ 'common.fields.total' | transloco }}</strong>
            </th>
            <th *ngIf="kitchen_content">
                <strong>{{ 'common.labels.qty' | transloco }}</strong>
            </th>
            <th *ngIf="kitchen_content" [hidden]="!orgType?.IsItemPriceSettingBase">
                <strong>{{ 'common.fields.total' | transloco }}</strong>
            </th>
        </tr>
        <tr *ngFor="let item of page?.items">
            <td *ngIf="!kitchen_content">{{ item?.quantity }}x {{ item?.item?.name || item?.name }}</td>
            <td *ngIf="!kitchen_content">
                {{ '@ ' + (item?.unit_price || item?.price || item?.pricePerUnit | number) }}
            </td>
            <td *ngIf="!kitchen_content">
                {{ item?.quantity * (item?.pricePerUnit || item?.unit_price || item?.price) | number: '1.2-2' }}
            </td>
            <td *ngIf="kitchen_content">
                {{ item?.item?.name || item?.name }}
            </td>
            <td *ngIf="kitchen_content">X {{ item?.quantity }}</td>
            <td *ngIf="kitchen_content" [hidden]="!orgType?.IsItemPriceSettingBase">
                {{ item?.quantity * item?.unit_price || item?.quantity * item?.price | number: '1.2-2' }}
            </td>
        </tr>
    </table>
    <table>
        <tr *ngIf="kitchen_content" [hidden]="!orgType?.IsSubTotalSettingBase">
            <th>Total Items: {{ page?.items?.length + page?.deals?.length }}</th>
            <td>{{ 'webapp.dashboard.sub_total' | transloco }}</td>
            <td>{{ getSubtotal(page.items)?.toFixed(2) }}</td>
        </tr>
        <tr *ngIf="!kitchen_content">
            <th>Total Items: {{ page?.items?.length + page?.deals?.length }}</th>
            <td>{{ 'webapp.dashboard.sub_total' | transloco }}</td>
            <td>
                {{ invoiceData ? (invoiceData?.SubTotal | number: '1.2-2') : '' }}
            </td>
        </tr>

        <!-- TODO wiil be added back in future -->
        <!-- <tr *ngIf="!kitchen_content && invoiceData?.is_online">
            <td>Fee @ {{ (invoiceData?.service_fee | number : '1.2-2') + '%' }}</td>
            <td></td>
            <td>{{invoiceData ? (invoiceData?.service_fee_amount | number : '1.2-2') : ''}}</td>
        </tr> -->
        <tr *ngIf="!kitchen_content && !invoiceData?.IsOnline && invoiceData?.OrderTypeId === orderType?.dine_inn?.id">
            <th>
                Service Charges
                {{
                    orgType?.IsServiceChargesEnable && orgType?.IsServiceChargesInPercentage
                        ? ' @ ' + invoiceData?.ServiceOrDeliveryChargesPercent + '%'
                        : ''
                }}
            </th>
            <td></td>
            <td>
                {{ invoiceData ? (invoiceData?.service_charge_amount | number: '1.2-2') : '0' }}
            </td>
        </tr>
        <tr *ngIf="!kitchen_content && !invoiceData?.IsOnline && invoiceData?.OrderTypeId === orderType?.delivery?.id">
            <th>{{ 'webapp.pos.fields.deliveryCharge' | transloco }}</th>
            <td></td>
            <td>
                {{ invoiceData ? (invoiceData?.delivery_charge_amount | number: '1.2-2') : '0' }}
            </td>
        </tr>
        <tr
            *ngIf="
                (!orgType?.IsDiscountInPercentage &&
                    orgType?.IsDiscountEnableToStaff &&
                    invoiceData?.DiscountToRupees) ||
                invoiceData?.Discount
            "
        >
            <th *ngIf="!kitchen_content">Discount &#64; {{ (invoiceData?.Discount).toFixed(2) }}%</th>
            <td></td>
            <td *ngIf="!kitchen_content">{{ (invoiceData?.DiscountToRupees).toFixed(2) }}/-</td>
        </tr>
        <tr *ngIf="!kitchen_content && !invoiceData?.IsOnline" [hidden]="!taxNtnCheck(invoiceData?.tax)">
            <th>STS &#64; {{ (invoiceData?.Tax | number: '1.2-2') + '%' }}</th>
            <td></td>
            <td>
                {{ invoiceData ? (invoiceData?.TaxToRupees | number: '1.2-2') : '0' }}
            </td>
        </tr>
        <tr *ngIf="!kitchen_content">
            <th>{{ 'webapp.dashboard.grand_total' | transloco }}</th>
            <td>
                <span *ngIf="!kitchen_content && invoiceData?.IsCompleted">{{ invoiceData?.payment_type }}</span>
            </td>
            <td>
                <strong>{{ (invoiceData?.total | number: '1.2-2') + ' PKR' }}</strong>
            </td>
        </tr>
        <ng-container *ngIf="!kitchen_content && orgType?.IsMultiplePaymentMethod">
            <tr>
                <td>{{ 'common.labels.cash' | transloco }}</td>
                <td></td>
                <td>{{ invoiceData?.received_payment }}</td>
            </tr>
            <tr>
                <td>{{ 'webapp.dashboard.change_balance' | transloco }}</td>
                <td></td>
                <td>
                    <span>{{ remainingAmount }}</span>
                </td>
            </tr>
        </ng-container>

        <tr>
            <td *ngIf="!kitchen_content && invoiceData?.IsOnline">
                {{ 'webapp.general.incltax_and_fees' | transloco }}
            </td>
        </tr>
        <tr *ngIf="!kitchen_content">
            <th colspan="3"></th>
        </tr>
    </table>
    <table class="comments new-comments margin-bottom-10" *ngIf="orgType?.IsCommentsEnable && kitchen_content">
        <tr>
            <th>{{ 'common.labels.comments' | transloco }}</th>
            <td>{{ invoiceData?.comments || 'N/A' }}</td>
        </tr>
    </table>
    <div class="text-center">
        <h6 *ngIf="!kitchen_content">{{ 'webapp.general.thank_you_for_visiting' | transloco }}</h6>
        <p class="flex-box footer">
            <span *ngIf="!kitchen_content">{{ 'webapp.general.software_by_smsami' | transloco }}</span>
            <span *ngIf="!kitchen_content">{{ 'webapp.general.ph_09155937150333_9895550' | transloco }}</span>
        </p>
    </div>
</section>
